<template>
  <b-container fluid>
    <div v-if="einladungen.length">
      <b-nav tabs fill>
        <b-nav-item to="../dokumente" active>{{$t('Briefkasten')}}</b-nav-item>
        <b-nav-item to="../einladungen">{{$t('Einladungen')}}</b-nav-item>
      </b-nav>
    </div>
    <b-form inline class="mt-3">
      <b-form-select
        v-model="selected"
        :options="options"
        text-field="text"
        value-field="value"
        name="$t('Jahr')"
        class="custom-select"
      ></b-form-select>
    </b-form>
    <div role="tablist" class="mt-3">
      <b-card v-for="(gruppe,ix) in dokumente" v-bind:key="ix" no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-btn block href="#" v-b-toggle="'gruppe' + ix" variant="primary">{{ gruppe.title }}</b-btn>
        </b-card-header>
        <b-collapse
          :id="'gruppe' + ix"
          :visible="ix === 0"
          accordion="dokumente"
          role="tabpanel"
          @show="collapseIsShowing(gruppe.title)"
        >
          <b-card-body>
            <b-row v-for="(dokument,docix) in gruppe.items" v-bind:key="docix">
              <b-col v-if="dokument.monthChanged" md="3" class="text-left">
                <strong>{{ moment().month(dokument.month-1).locale($route.params.lang + "_ch").format("MMMM") }}</strong>
              </b-col>
              <b-col v-if="!dokument.monthChanged" md="3" class="text-left"></b-col>
              <b-col md="9" class="text-left">
                <b-link
                  @click.stop="loadDokument(dokument,ix,docix)"
                  href="#"
                  target="_blank"
                  :class="{ viewed: dokument.viewed }"
                >
                  <img :src="'images/'+dokument.fileType+'.gif'" />
                  {{ dokument.title }} {{ convertTime(dokument.date) }}
                </b-link>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </b-container>
</template>

<script>
import moment from "moment";

export default {
  name: "dokumente",
  props: {
    year: {
      type: Number /* 2020,2019, kommt direkt via Router */
    },
    lang: {
      type: String /* de/fr/it via router */
    }
  },
  data() {
    return {
      docKey:this.year.toString()+'_'+this.lang // '2019_de'
    };
  },
  computed: {
    options() {
      var opt = [];
      for (var year = new Date().getFullYear(); year >= 2006; year--) {
        opt.push({ text: year, value: year });
      }
      return opt;
    },
    dokumenteAlle() {
      return this.$store.state.dokumenteStore.dokumente;
    },
    dokumente() {
      // ..dokumenteStore.dokumente['2019_de'][{dokX},{dokX}...]
      let test = this.dokumenteAlle[this.docKey];
      return test ? test : [];
    },
    einladungen() {
      return this.$store.state.einladungenStore.einladungen;
    },
    selected: {
      get: function() {
        return this.year;
      },
      set: function(nextYear) {
        // Trigger vue router
        this.$router.push(
          "/" + this.$route.params.lang + "/dokumente/" + nextYear.toString()
        );
      }
    }
  },
  methods: {
    moment: function() {
      return moment();
    },
    convertTime(value) {
      return moment(value).format("DD.MM.YYYY");
    },
    loadDokument(dokument, ix, docix) {
      if (
        !dokument.viewed &&
        this.$store.state.userStore.token.masterDomain === 0
      ) {
        // gelesen nur abbuchen wenn kein Domswitch(masterdomain)
        //dokument.viewed = true
        let doc = {
          yearlang: this.selected.toString() + "_" + this.$i18n.locale,
          groupIndex: ix,
          docIndex: docix
        };
        this.$store.commit("setGelesen", doc);
        this.$store.commit("decUngelesen");
      }
      document.location.href = dokument.url;
    },
    collapseIsShowing(title) {
      // google analytics informieren, pseudoroute ..
      this.$ga.page(
        this.$route.path +
          "/" +
          this.selected.toString() +
          "/" +
          encodeURI(title)
      );
    }
  },
  created() {
    let self = this;
    this.$nextTick(async function() {
      self.$store.dispatch("loadDokumente", {
        year: self.year,
        locale: self.lang
      });
      self.$store.dispatch("loadUngelesen");
    });
  },
  updated() {},
  mounted() {},
  components: {}
};
</script>

<style lang="scss" scoped>
@import "../../public/css/tsmVars.scss";
a.viewed {
  color: $tsmtext !important;
}
a.viewed > img {
  filter: grayscale(100%);
}
</style>